import {
  Divider,
  Grid,
  Stack,
  styled,
  Typography,
  type CSSObject,
} from '@mui/material';
import { Button } from '@rumblefish/ui/Rumblefish23Theme';

export const TextStyledStack = styled(Stack)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
  margin: theme.spacing(10, 0),
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  '.MuiStack-root': {
    backgroundColor: 'transparent !important',
    border: '1px solid white',
    boxShadow: `0px 0px 6px 4px ${theme.palette.raspberryColors?.PLUS_2}, 0px 0px 6px 4px ${theme.palette.raspberryColors?.PLUS_2} inset !important`,
  },
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
  ...(theme.mixins.neutralGradient as CSSObject),
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  marginBottom: theme.spacing(2),

  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export const StyledDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette.invertedContent?.TETRIARY,
  maxWidth: '55%',
  [theme.breakpoints.down('md')]: {
    maxWidth: '100%',
  },
}));

export const StyledCitationWrapper = styled('div')(
  ({ theme: { breakpoints } }) => ({
    gridColumn: '9/13',
    gridRow: 2,
    position: 'relative',
    top: '70%',
    [breakpoints.down('sm')]: {
      gridColumn: '2/12',
      top: '-2%',
      gridRow: '2',
      right: 0,
    },
    [`& > img`]: {
      position: 'relative',
      top: '5%',
      left: '-5%',
      [breakpoints.down('md')]: {
        left: '-8%',
        top: '8%',
      },
      [breakpoints.down('sm')]: {
        top: '20%',
        left: '-5%',
      },
    },
    ['& > span']: {
      position: 'relative',
      zIndex: 10,
    },
  })
);

export const StyledAvatarBoxMargin = styled(Stack)(() => ({
  marginTop: '32px',
}));

export const StyledVerticalDivider = styled(Divider)(({ theme }) => ({
  background: theme.palette.greyBackgroundColor?.SURFACE + '50',
}));

export const StyledHorizontalDivider = styled(Divider)(({ theme }) => ({
  background: theme.palette.greyBackgroundColor?.SURFACE + '10',
  marginBottom: theme.spacing(8),
}));

export const StyledAvatarJob = styled(Typography)(({ theme: { palette } }) => ({
  color: palette.colorBrand?.secondary,
}));

export const StyledPhotoGrid = styled(Grid)(
  ({ theme: { breakpoints, spacing } }) => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 8.33%)',
    gridTemplateRows: '1fr 1fr',
    pointerEvents: 'none',
    marginBottom: spacing(26),
    [breakpoints.down('lg')]: {
      marginBottom: spacing(32),
    },
    [breakpoints.down('md')]: {
      marginBottom: spacing(46),
    },
    [breakpoints.down('sm')]: {
      gridTemplateRows: '1fr 1fr 1fr',
      marginBottom: spacing(2),
    },
  })
);

export const StyledPhoto1 = styled('img')(({ theme: { breakpoints } }) => ({
  position: 'relative',
  gridColumn: '8/12',
  width: '100%',
  [breakpoints.up('lg')]: {
    top: '-15%',
  },

  [breakpoints.down('sm')]: {
    gridColumn: '8/13',
  },
}));

export const StyledPhoto2 = styled('img')(({ theme: { breakpoints } }) => ({
  position: 'relative',
  top: '20%',
  gridColumn: '2/6',
  gridRow: 1,
  width: '100%',
  [breakpoints.down('sm')]: {
    gridColumn: '1/6',
  },
}));
export const StyledPhoto3 = styled('img')(({ theme: { breakpoints } }) => ({
  position: 'relative',
  top: '-65%',
  gridRow: 2,
  gridColumn: '7/12',
  width: '100%',
  [breakpoints.down('sm')]: {
    gridColumn: '8/13',
    top: '-50%',
  },
}));
export const StyledPhoto4 = styled('img')(({ theme: { breakpoints } }) => ({
  position: 'relative',
  top: '10%',
  gridColumn: '1/8',
  gridRow: 2,
  width: '100%',
  [breakpoints.down('sm')]: {
    display: 'none',
  },
}));
export const StyledPhoto5 = styled('img')(({ theme: { breakpoints } }) => ({
  position: 'relative',
  top: '30%',
  gridColumn: '9/13',
  gridRow: 2,
  width: '100%',
  [breakpoints.down('sm')]: {
    top: '10%',
    gridColumn: '1/13',
    gridRow: 3,
  },
}));
